import './styles.scss';
export function DayClosed (){
    let opennedInDay = "";
    let opennedInHour = "";
    let textColor = "textOpenned";

    const datesClosed = [
        "2024-12-20",
        "2024-12-21",
        "2024-12-22",
        "2024-12-23",
        "2024-12-24",
        "2024-12-25",
        "2024-12-26",
        "2024-12-27",
        "2024-12-28",
        "2024-12-29",
        "2024-12-30",
        "2024-12-31",
        "2025-01-01",
        "2025-01-02",
        "2025-01-03",
        "2025-01-04",
        "2025-01-05",
        "2025-01-06",
        "2025-01-07",
        "2025-01-08",
        "2025-01-09",
        "2025-01-10",
        "2025-01-11",
        "2025-01-12",
        "2025-01-13",
        "2025-01-14",
        
        
    ];
    let closed = false;
    
    const momentRightNow = new Date(); //Data e Hora atual
    const weekDay = momentRightNow.getDay(); // Dia da semana de 0 a 6
    const fullYear = momentRightNow.getFullYear(); // Ano
    const month = momentRightNow.getMonth(); // Mes
    const day = momentRightNow.getDate();// Dia no mês
    const hour = momentRightNow.getHours(); // Hora
    const minutes = momentRightNow.getMinutes(); // Minutos
    const today = (
                    `${fullYear}
                    -${month + 1}
                    -${day}`
                    ).toString(); // data formato aaaa-mm-dd
    
    datesClosed.map((datas) => {
        if(datas === today) { 
            closed = true;
            opennedInDay="Fechado hoje";
            textColor = "textClosed";
        }
        return datas;
    })

    if(!closed){
        if (weekDay < 1 || weekDay > 5) {
            opennedInDay = "Fechado hoje"
            textColor = "textClosed";
        }else{
            if( 
                (
                    ((hour >= 8 && minutes >= 30)
                      || (hour >= 9)
                    ) 
                    && 
                    (hour < 12)
                ) 
                || 
                (
                    ((hour >= 13 && minutes >=30)
                        || (hour>=14)
                    ) 
                    && 
                    (hour < 18)
                )
            ) opennedInDay = "Aberto agora"; else {opennedInDay = "Fechado agora"; textColor = "textClosed";}

        }

        if((hour === 8 || hour === 13) && (minutes >= 14 && minutes < 30  )){
            opennedInHour = "Abre em breve...";
        }
        if((hour === 11 || hour === 17) && (minutes > 44 && minutes <= 59  )){
            opennedInHour = "Fecha em breve...";
        }
    }

    return (
        <div className='dayClosed'>
            <strong className={`${textColor}`}>{opennedInDay}</strong>
            <div>{opennedInHour}</div>
        </div>
    )
}
